module.exports = __webpack_public_path__ + "img/grid-srp-preview-nissan.575426d6.png";